import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "end",
  "use": "end-usage",
  "viewBox": "0 0 38 38",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 38 38\" id=\"end\">\n    <g fill=\"none\" fill-rule=\"evenodd\" transform=\"translate(6.333 6.333)\">\n        <path fill=\"#3F65FF\" fill-rule=\"nonzero\" d=\"M24.565 15.081l-9.475 9.477a2.642 2.642 0 01-3.74 0L0 13.218V0h13.214l11.35 11.354a2.644 2.644 0 010 3.727z\" />\n        <circle cx=\"7.389\" cy=\"7.389\" r=\"2.111\" fill=\"#FFF\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol